import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'absolute',
})
export class AbsPipe implements PipeTransform {
    transform(num?: number): any {
        if (!num) return num;
        return Math.abs(num);
    }
}
